/**
 * Domain Configuration
 * This file is auto-generated based on the DOMAIN_NAME environment variable
 * Used to replace {{DOMAIN_NAME}} placeholders in locale files
 * 
 * Generated at: 2026-03-30T14:13:40.923Z
 */

// Domain name from environment variable (set at build time)
export const DOMAIN_NAME = 'treffen-milf.de'

export default DOMAIN_NAME
